module.exports = __webpack_public_path__ + "img/incosnciente@x1.db0b26ad.png";